// removed by extract-text-webpack-plugin
module.exports = {"oops":"oops__58d6c633302467ad3429c9ffa73085dd"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/ErrorBoundary/style.scss
// module id = 1707
// module chunks = 55